import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { useAuth } from '../../../../../context/AuthContext';
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

export const AdminAssignPackage = () => {
    const { user } = useAuth();
    const [msg, setMsg] = useState("");
    const [mode, setMode] = useState("individual"); // individual | corporate

    const headerss = {
        accept: "*/*",
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": "false",
        Authorization: "Bearer " + user.token
    };

    return (
        <div className="container-fluid py-3 py-md-4">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-9 col-xl-8">
                    <div className="card shadow-sm border-0">
                        <div className="card-body p-3 p-md-4">
                            <div className="text-center mb-4">
                                <h1 className="h3 mb-1">Manuel Paket Tanımla / Düzelt</h1>
                                <p className="text-muted mb-0">
                                    Talep göndermesine gerek kalmadan bir üyeye/okula paket tanımlayın veya
                                    yanlış tanımlanmış bir kursu/paketi kaldırın.
                                </p>
                            </div>

                            <div className="d-flex justify-content-center gap-2 mb-4">
                                <button
                                    className={`btn ${mode === "individual" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => { setMode("individual"); setMsg(""); }}
                                >
                                    Bireysel
                                </button>
                                <button
                                    className={`btn ${mode === "corporate" ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => { setMode("corporate"); setMsg(""); }}
                                >
                                    Kurumsal
                                </button>
                            </div>

                            {msg ? <div className="alert alert-danger">{msg}</div> : null}

                            {mode === "individual"
                                ? <IndividualAssign headerss={headerss} setMsg={setMsg} />
                                : <CorporateAssign headerss={headerss} setMsg={setMsg} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const IndividualAssign = ({ headerss, setMsg }) => {
    const [members, setMembers] = useState([]);
    const [loadingMembers, setLoadingMembers] = useState(true);
    const [memberSearch, setMemberSearch] = useState("");

    const [courses, setCourses] = useState([]);
    const [packages, setPackages] = useState([]);
    const [loadingPackages, setLoadingPackages] = useState(true);

    const [userDetail, setUserDetail] = useState(null);
    const [loadingUserDetail, setLoadingUserDetail] = useState(false);

    const [userTransactions, setUserTransactions] = useState([]);
    const [loadingUserTransactions, setLoadingUserTransactions] = useState(false);

    const [packageId, setPackageId] = useState("");
    const [note, setNote] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const [usersRes, coursesRes, packagesRes] = await Promise.all([
                    axios.get(API_BASE_URL + "/admin/User/GetUsers", { headers: headerss }),
                    axios.get(API_BASE_URL + "/admin/CourseManager/GetCourses", { headers: headerss }),
                    axios.get(API_BASE_URL + "/admin/Package/GetList", { headers: headerss }),
                ]);

                if (usersRes.data?.success) {
                    const list = (usersRes.data.data || [])
                        .filter(item => item?.user?.isInvidual && item?.user?.isStudent)
                        .map(item => ({
                            id: item.user.id,
                            username: item.user.username,
                            fullName: item.user.fullName,
                        }));
                    setMembers(list);
                } else {
                    setMsg(usersRes.data?.message || "Üye listesi alınamadı.");
                }

                if (coursesRes.data?.success) {
                    setCourses(coursesRes.data.data || []);
                }

                if (packagesRes.data?.success) {
                    const activePackages = (packagesRes.data.data || []).filter(
                        p => p.isActive && p.isInvidual
                    );
                    setPackages(activePackages);
                }
            } catch (err) {
                setMsg(err.message);
            }
            setLoadingMembers(false);
            setLoadingPackages(false);
        };
        fetchAll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const term = memberSearch.trim().toLowerCase();
        const match = members.find(m => (m.username || "").toLowerCase() === term);
        setUserDetail(null);
        setUserTransactions([]);

        if (match) {
            fetchUserDetail(match.id);
            fetchUserTransactions(match.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [memberSearch, members]);

    const fetchUserDetail = async (userId) => {
        setLoadingUserDetail(true);
        try {
            const res = await axios.get(API_BASE_URL + "/admin/User/GetUserById", {
                params: { userId },
                headers: headerss
            });
            if (res.data?.success) {
                setUserDetail(res.data.data);
            } else {
                setMsg(res.data?.message || "Üye bilgisi alınamadı.");
            }
        } catch (err) {
            setMsg(err.message);
        }
        setLoadingUserDetail(false);
    };

    const fetchUserTransactions = async (userId) => {
        setLoadingUserTransactions(true);
        try {
            const res = await axios.get(API_BASE_URL + "/admin/Subscription/GetUserTransactions", {
                params: { userId },
                headers: headerss
            });
            if (res.data?.success) {
                setUserTransactions(res.data.data || []);
            } else {
                setMsg(res.data?.message);
            }
        } catch (err) {
            setMsg(err.message);
        }
        setLoadingUserTransactions(false);
    };

    const getCourseName = (courseId) => {
        const c = courses.find(x => x.id === courseId);
        return c ? c.courseName : `#${courseId}`;
    };

    const getPackageName = (pkgId) => {
        const p = packages.find(x => x.id === pkgId);
        return p ? p.packageName : `#${pkgId}`;
    };

    const handleRejectTransaction = async (transactionId) => {
        const confirm = await Swal.fire({
            title: "Bu satın alım/atama yanlış mı? Kaldırılsın mı?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Kaldır",
            cancelButtonText: "Vazgeç"
        });
        if (!confirm.isConfirmed) return;

        try {
            const res = await axios.get(API_BASE_URL + "/admin/Subscription/Reject", {
                params: { transactionId, note: "Admin: hatalı bireysel atama düzeltmesi" },
                headers: headerss
            });
            if (res.data?.success) {
                Swal.fire("Başarılı", "Kaldırıldı.", "success");
                fetchUserTransactions(userDetail.user.id);
            } else {
                Swal.fire("Hata", res.data?.message, "error");
            }
        } catch (err) {
            Swal.fire("Hata", err.message, "error");
        }
    };

    const handleRemoveCourse = async (courseId) => {
        const confirm = await Swal.fire({
            title: "Bu kursu kaldırmak istediğinize emin misiniz?",
            text: getCourseName(courseId),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Kaldır",
            cancelButtonText: "Vazgeç"
        });
        if (!confirm.isConfirmed) return;

        try {
            const res = await axios.post(
                API_BASE_URL + "/admin/User/RemoveUserCourse",
                { userId: userDetail.user.id, courseId },
                { headers: headerss }
            );
            if (res.data?.success) {
                Swal.fire("Başarılı", "Kurs kaldırıldı.", "success");
                fetchUserDetail(userDetail.user.id);
            } else {
                Swal.fire("Hata", res.data?.message, "error");
            }
        } catch (err) {
            Swal.fire("Hata", err.message, "error");
        }
    };

    const handleAssign = async (e) => {
        e.preventDefault();
        if (!userDetail || !packageId) {
            Swal.fire("Uyarı", "Lütfen üye ve paket seçiniz.", "warning");
            return;
        }

        setSubmitting(true);
        try {
            const res = await axios.post(
                API_BASE_URL + "/admin/Subscription/AdminAssign",
                null,
                {
                    params: { userId: userDetail.user.id, packageId, note },
                    headers: headerss
                }
            );
            if (res.data?.success) {
                Swal.fire("Başarılı", "Paket tanımlandı/uzatıldı.", "success");
                setNote("");
                fetchUserDetail(userDetail.user.id);
                fetchUserTransactions(userDetail.user.id);
            } else {
                Swal.fire("Hata", res.data?.message, "error");
            }
        } catch (err) {
            Swal.fire("Hata", err.message, "error");
        }
        setSubmitting(false);
    };

    return (
        <>
            <div className="mb-4">
                <label className="form-label"><strong>1. Üye Ara</strong></label>
                <input
                    type="text"
                    className="form-control"
                    placeholder={loadingMembers ? "Üyeler yükleniyor..." : "İsim veya e-posta ile ara..."}
                    value={memberSearch}
                    onChange={(e) => setMemberSearch(e.target.value)}
                    disabled={loadingMembers}
                    list="assignMemberSuggestions"
                    autoComplete="off"
                />
                <datalist id="assignMemberSuggestions">
                    {members.map((m) => (
                        <option key={m.username} value={m.username}>{m.fullName}</option>
                    ))}
                </datalist>
            </div>

            {loadingUserDetail && <div className="text-center mb-3">Üye bilgisi yükleniyor...</div>}

            {userDetail && (
                <>
                    <div className="alert alert-info">
                        <strong>{userDetail.user.fullName}</strong> - {userDetail.user.username}
                        <br />
                        Geçerlilik tarihi: {userDetail.user.expiryDate ? new Date(userDetail.user.expiryDate).toLocaleDateString() : "-"}
                    </div>

                    <div className="mb-4">
                        <label className="form-label"><strong>Mevcut Satın Alımları</strong></label>
                        {loadingUserTransactions && <div className="text-muted">Yükleniyor...</div>}
                        {!loadingUserTransactions && userTransactions.length === 0 && (
                            <div className="text-muted">Bu üyenin onaylanmış bir satın alımı/ataması yok.</div>
                        )}
                        {userTransactions.map((tx) => (
                            <div key={tx.id} className="d-flex justify-content-between align-items-center border rounded p-2 mb-2">
                                <span>{getPackageName(tx.package)} - {tx.type} - {new Date(tx.transactionDate).toLocaleDateString()}</span>
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleRejectTransaction(tx.id)}
                                >
                                    Kaldır
                                </button>
                            </div>
                        ))}
                    </div>

                    <div className="mb-4">
                        <label className="form-label"><strong>Mevcut Kursları</strong></label>
                        {(!userDetail.educationals || userDetail.educationals.length === 0) && (
                            <div className="text-muted">Bu üyenin tanımlı bir kursu yok.</div>
                        )}
                        {(userDetail.educationals || []).map((edu) => (
                            <div key={edu.courseId} className="d-flex justify-content-between align-items-center border rounded p-2 mb-2">
                                <span dangerouslySetInnerHTML={{ __html: getCourseName(edu.courseId) }} />
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleRemoveCourse(edu.courseId)}
                                >
                                    Kaldır
                                </button>
                            </div>
                        ))}
                    </div>

                    <form onSubmit={handleAssign}>
                        <div className="mb-3">
                            <label className="form-label"><strong>2. Paket Seç</strong></label>
                            <select
                                className="form-select"
                                value={packageId}
                                onChange={(e) => setPackageId(e.target.value)}
                                disabled={loadingPackages}
                                required
                            >
                                <option value="">
                                    {loadingPackages ? "Paketler yükleniyor..." : "Paket seçiniz"}
                                </option>
                                {packages.map((p) => (
                                    <option key={p.id} value={p.id}>
                                        {p.packageName} - {p.packagePrice} TL - {p.howManyDays} gün
                                    </option>
                                ))}
                            </select>
                            <small className="text-muted">
                                Üyenin bu paketin kursuna ait kaydı yoksa yeni kurs olarak eklenir, varsa süresi uzatılır.
                                Yanlış kursu önce yukarıdan kaldırmayı unutmayın.
                            </small>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Not (isteğe bağlı)</label>
                            <textarea
                                className="form-control"
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                rows={2}
                                placeholder="örn. Yanlış paket düzeltmesi"
                            />
                        </div>

                        <div className="d-flex justify-content-center">
                            <button type="submit" className="btn btn-primary btn-lg px-4" disabled={submitting}>
                                {submitting ? "İşleniyor..." : "Paketi Tanımla / Uzat"}
                            </button>
                        </div>
                    </form>
                </>
            )}
        </>
    );
};

const CorporateAssign = ({ headerss, setMsg }) => {
    const [schools, setSchools] = useState([]);
    const [loadingSchools, setLoadingSchools] = useState(true);
    const [schoolSearch, setSchoolSearch] = useState("");
    const [selectedSchool, setSelectedSchool] = useState(null);

    const [packages, setPackages] = useState([]);
    const [loadingPackages, setLoadingPackages] = useState(true);

    const [schoolTransactions, setSchoolTransactions] = useState([]);
    const [loadingTransactions, setLoadingTransactions] = useState(false);

    const [packageId, setPackageId] = useState("");
    const [note, setNote] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const [schoolsRes, packagesRes] = await Promise.all([
                    axios.get(API_BASE_URL + "/admin/School/SchoolList", { headers: headerss }),
                    axios.get(API_BASE_URL + "/admin/Package/GetList", { headers: headerss }),
                ]);

                if (schoolsRes.data?.success) {
                    setSchools(schoolsRes.data.data || []);
                } else {
                    setMsg(schoolsRes.data?.message || "Okul listesi alınamadı.");
                }

                if (packagesRes.data?.success) {
                    const corporatePackages = (packagesRes.data.data || []).filter(
                        p => p.isActive && !p.isInvidual
                    );
                    setPackages(corporatePackages);
                }
            } catch (err) {
                setMsg(err.message);
            }
            setLoadingSchools(false);
            setLoadingPackages(false);
        };
        fetchAll();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const term = schoolSearch.trim().toLowerCase();
        const match = schools.find(s => (s.schoolName || "").toLowerCase() === term);
        setSelectedSchool(match || null);
        setSchoolTransactions([]);

        if (match) {
            fetchSchoolTransactions(match.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [schoolSearch, schools]);

    const fetchSchoolTransactions = async (schoolId) => {
        setLoadingTransactions(true);
        try {
            const res = await axios.get(API_BASE_URL + "/admin/Subscription/GetSchoolTransactions", {
                params: { schoolId },
                headers: headerss
            });
            if (res.data?.success) {
                setSchoolTransactions(res.data.data || []);
            } else {
                setMsg(res.data?.message);
            }
        } catch (err) {
            setMsg(err.message);
        }
        setLoadingTransactions(false);
    };

    const getPackageName = (pkgId) => {
        const p = packages.find(x => x.id === pkgId);
        return p ? p.packageName : `#${pkgId}`;
    };

    const handleRejectTransaction = async (transactionId) => {
        const confirm = await Swal.fire({
            title: "Bu ataması yanlış mı? Kaldırılsın mı?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Kaldır",
            cancelButtonText: "Vazgeç"
        });
        if (!confirm.isConfirmed) return;

        try {
            const res = await axios.get(API_BASE_URL + "/admin/Subscription/Reject", {
                params: { transactionId, note: "Admin: hatalı kurumsal atama düzeltmesi" },
                headers: headerss
            });
            if (res.data?.success) {
                Swal.fire("Başarılı", "Kaldırıldı.", "success");
                fetchSchoolTransactions(selectedSchool.id);
            } else {
                Swal.fire("Hata", res.data?.message, "error");
            }
        } catch (err) {
            Swal.fire("Hata", err.message, "error");
        }
    };

    const handleAssign = async (e) => {
        e.preventDefault();
        if (!selectedSchool || !packageId) {
            Swal.fire("Uyarı", "Lütfen okul ve paket seçiniz.", "warning");
            return;
        }

        setSubmitting(true);
        try {
            const res = await axios.post(
                API_BASE_URL + "/admin/Subscription/AdminAssignSchool",
                null,
                {
                    params: { schoolId: selectedSchool.id, packageId, note },
                    headers: headerss
                }
            );
            if (res.data?.success) {
                Swal.fire("Başarılı", "Paket tanımlandı/uzatıldı, okulun tüm öğrencilerinin süresi de eşzamanlandı.", "success");
                setNote("");
                fetchSchoolTransactions(selectedSchool.id);
            } else {
                Swal.fire("Hata", res.data?.message, "error");
            }
        } catch (err) {
            Swal.fire("Hata", err.message, "error");
        }
        setSubmitting(false);
    };

    return (
        <>
            <div className="mb-4">
                <label className="form-label"><strong>1. Okul Ara</strong></label>
                <input
                    type="text"
                    className="form-control"
                    placeholder={loadingSchools ? "Okullar yükleniyor..." : "Okul adı ile ara..."}
                    value={schoolSearch}
                    onChange={(e) => setSchoolSearch(e.target.value)}
                    disabled={loadingSchools}
                    list="assignSchoolSuggestions"
                    autoComplete="off"
                />
                <datalist id="assignSchoolSuggestions">
                    {schools.map((s) => (
                        <option key={s.id} value={s.schoolName} />
                    ))}
                </datalist>
            </div>

            {selectedSchool && (
                <>
                    <div className="alert alert-info">
                        <strong>{selectedSchool.schoolName}</strong>
                        <br />
                        Geçerlilik tarihi: {selectedSchool.expiryDate ? new Date(selectedSchool.expiryDate).toLocaleDateString() : "-"}
                        {" "}·{" "}
                        Durum: {selectedSchool.isActive ? "Aktif" : "Pasif"}
                    </div>

                    <div className="mb-4">
                        <label className="form-label"><strong>Onaylanmış Kurumsal Paketleri</strong></label>
                        {loadingTransactions && <div className="text-muted">Yükleniyor...</div>}
                        {!loadingTransactions && schoolTransactions.length === 0 && (
                            <div className="text-muted">Bu okulun onaylanmış bir paketi yok.</div>
                        )}
                        {schoolTransactions.map((tx) => (
                            <div key={tx.id} className="d-flex justify-content-between align-items-center border rounded p-2 mb-2">
                                <span>{getPackageName(tx.package)} - {new Date(tx.transactionDate).toLocaleDateString()}</span>
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleRejectTransaction(tx.id)}
                                >
                                    Kaldır
                                </button>
                            </div>
                        ))}
                    </div>

                    <form onSubmit={handleAssign}>
                        <div className="mb-3">
                            <label className="form-label"><strong>2. Paket Seç</strong></label>
                            <select
                                className="form-select"
                                value={packageId}
                                onChange={(e) => setPackageId(e.target.value)}
                                disabled={loadingPackages}
                                required
                            >
                                <option value="">
                                    {loadingPackages ? "Paketler yükleniyor..." : "Paket seçiniz"}
                                </option>
                                {packages.map((p) => (
                                    <option key={p.id} value={p.id}>
                                        {p.packageName} - {p.packagePrice} TL - {p.howManyDays} gün
                                    </option>
                                ))}
                            </select>
                            <small className="text-muted">
                                Atama/uzatma yapıldığında okulun tüm öğrencilerinin geçerlilik süresi de otomatik eşzamanlanır.
                            </small>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Not (isteğe bağlı)</label>
                            <textarea
                                className="form-control"
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                rows={2}
                                placeholder="örn. Yanlış paket düzeltmesi"
                            />
                        </div>

                        <div className="d-flex justify-content-center">
                            <button type="submit" className="btn btn-primary btn-lg px-4" disabled={submitting}>
                                {submitting ? "İşleniyor..." : "Paketi Tanımla / Uzat"}
                            </button>
                        </div>
                    </form>
                </>
            )}
        </>
    );
};

export default AdminAssignPackage;
